export default __webpack_public_path__ + "static/media/undraw_Finance_re_gnv2.83703b63.svg";